// The free-delivery threshold (settings.transportation.free, «Δωρεάν Μεταφορικά από»): delivery is free once the products
// subtotal REACHES it. It is saved from a text box, so it arrives as a string - most shops keep a huge one meaning "never
// free" - and anything that is not a positive number means there is no threshold: the city's fee always applies. The
// dashboard / nexio (shared/services/deliveryFee.ts) and the customer apps use the same rule, so an order at exactly the
// threshold is free whichever app takes it (this checkout used to charge it, the dashboard did not).
export const freeDeliveryReached = (subtotal, threshold) => {
  const limit = +String(threshold ?? '').trim().replace(',', '.');
  return Number.isFinite(limit) && limit > 0 && +subtotal >= limit;
};

// A delivery city the shop still serves: the id of an ENABLED settings.citys row. A saved address can hold a city the
// shop has since switched off - the city list no longer offers it, but the value stayed and passed checkout.
export const isServedCity = (citys, id) => +id > 0 && (citys || []).some(c => c?.enabled && +c.id === +id);
